import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';
import RangeSlider from './RangeSlider';
import FilterTag from '../Components/FilterTags';
import Svg from './Svg';

class FacetedSearchGroup extends Component {
    constructor(props) {
        super(props);
        const isFilterGroupExpanded = false;
        this.state = {
            collapsed: false,
            showLessItemCount: 5,
            isFilterGroupExpanded
        };
        this.lastClickedNode = null;
        this.clickHandler = this.clickHandler.bind(this);
        this.toggleShowMore = this.toggleShowMore.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler);
        const visible = this.refs.list.getBoundingClientRect().height !== 0;
        const tooMuchItem = this.props.group.options.length > this.state.showLessItemCount;
        visible && tooMuchItem && this.toggleShowMore();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;
        if (!this.refs.list.contains(this.lastClickedNode)) {
            this.setState((prevState, props) => ({
                ...prevState,
                isFilterGroupExpanded: false,
                collapsed: false
            }));
        }
    }

    toggleShowMore() {
        const topPos = this.refs.list.getBoundingClientRect().top;
        const lessBottomPos = this.refs.showLess.getBoundingClientRect().bottom;
        const moreBottomPos = this.refs.showMore.getBoundingClientRect().bottom;
        const setHeight = () => this.refs.list.style.height = `${(this.state.collapsed ? lessBottomPos : moreBottomPos) - topPos}px`;
        const toggleCollapse = () => {
            this.setState((prevState, props) => ({
                collapsed: !prevState.collapsed
            }), () => {
                // setHeight();
            });
        }
        if (!this.refs.list.style.height) {
            // setHeight();
            setTimeout(() => { toggleCollapse() }, 0);
        }
        else {
            toggleCollapse();
        }
    }

    setIsFilterGroupExpanded() {
        const value = !this.state.isFilterGroupExpanded;
        this.setState((prevState, props) => ({
            ...prevState,
            isFilterGroupExpanded: value
        }));
    }

    expandedFilterGroupCssClass() {
        return this.state.isFilterGroupExpanded ? 'open' : '';
    }

    render() {
        const { group, searchFacetChange, sliderFilterChange, productId, visible } = this.props;
        return (
            <Fragment>
                <div className={`faceted-search__group ${visible ? 'visible' : 'hide'}`} ref="list">
                    <div className={`faceted-search__group-header-container ${this.expandedFilterGroupCssClass()}`} onClick={() => this.setIsFilterGroupExpanded(false)}>
                        <div className="faceted-search__group-header" role="faceted-search-item-group">{group.label}</div>
                        <Svg icon='arrow-right-thin' onClick={() => this.setIsFilterGroupExpanded()} />
                    </div>
                    <div className={`faceted-search__group-dropdown ${this.expandedFilterGroupCssClass()}`}>
                        {group.isSlider
                            ?
                            <div className={`input-range__container ${this.expandedFilterGroupCssClass()}`}>
                                <RangeSlider itemValue={group.options[0]} group={group} sliderFilterChange={sliderFilterChange} productId={productId} />
                            </div>
                            :
                            group.options && group.options.map((item, itemIndex, array) => (
                                <div key={`${item.label}-${itemIndex}`} className={`faceted-search__item ${this.expandedFilterGroupCssClass()}`} role="faceted-search-item" ref={itemIndex === this.state.showLessItemCount - 1 ? "showLess" : itemIndex === array.length - 1 ? "showMore" : null}>
                                    <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange} productId={productId} />
                                </div>
                            ))
                        }
                        <button className="buttonv2 buttonv2-primary buttonv2-small buttonv2--full-width" onClick={() => this.setIsFilterGroupExpanded(false)}>
                            {translate('energylabel.close')}
                        </button>
                    </div>

                </div>
            </Fragment>
        )
    }
}

const FacetedSearch = ({
                           facetFilters,
                           query,
                           searchFacetChange,
                           navigationTheme,
                           sliderFilterChange,
                           productId,
                           deselectAllFilterOptions,
                           innerRef,
                           showAll,
                           setShowAll,
                           visibleGroups,
                           isLoading
                       }) => navigationTheme !== 'category' && (
    <Fragment>
        <FilterTag {...{facetFilters, navigationTheme, searchFacetChange}}
                   deselectAllFilterOptions={deselectAllFilterOptions} productId={productId}/>
        <h4 className="subnav__header subnav__item">{translate('facet.header.filter')}</h4>
        <div className={`faceted-search ${showAll ? 'faceted-search--show-all' : ''}`} ref={innerRef}>
                {!isLoading ? 
                    facetFilters && facetFilters.map((group, groupIndex, array) => (
                      <FacetedSearchGroup key={`${group.label}-${groupIndex}`}
                                          visible={showAll || groupIndex < visibleGroups ? true : false} group={group}
                                          searchFacetChange={searchFacetChange} sliderFilterChange={sliderFilterChange}
                                          productId={productId}/>
                    ))
                    : <div className='faceted-search__skeleton-container'>
                        <div className='faceted-search__skeleton-element'></div>
                        <div className='faceted-search__skeleton-element'></div>
                        <div className='faceted-search__skeleton-element'></div>
                        <div className='faceted-search__skeleton-element'></div>
                      </div>}
            {visibleGroups < facetFilters.length && (
                <div className="faceted-search__load-more-item" id="faceted-search__load-more"
                     onClick={() => setShowAll(!showAll)}>
                    {!showAll ?
                        <span>{translate('filter.showmore')}
                            <Svg icon='plus'/>
                        </span>
                        : <span> {translate('filter.showless')} </span>
                    }
                </div>
            )}

        </div>
    </Fragment>
)

export const FacetedFilterCheckbox = ({ item, group, searchFacetChange, productId }) => (
    <label className="faceted-filter" >
        <input className="faceted-filter__input" type="checkbox" onChange={event => searchFacetChange(group, item, productId)} checked={group.selectedOptions !== null && group.selectedOptions.some(selectedOption => selectedOption.value === item.id)} />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) &&
                <span className="faceted-filter__quantity">&nbsp;({item.quantity})</span>
            }
        </span>
    </label>
)

export default FacetedSearch;
